import { doDelete, doGet, doPost, doPut } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import type {
  AssistantTaskResponse,
  AssistantTasksResponse,
  CategoryRequest,
} from './types';

export const getAssistantTasks = (accountId: string, projectId: string) => {
  return doGet<AssistantTasksResponse>(
    `accounts/${accountId}/projects/${projectId}/assistant-task-config`,
    LOGGER_TYPE.ANALYTICS,
    { prefix: 'nebula' },
  );
};

export const createAssistantTask = (
  accountId: string,
  projectId: string,
  taskName: string,
  question: string,
  prompt: string,
  categories: CategoryRequest[],
) => {
  return doPost<AssistantTaskResponse>(
    `accounts/${accountId}/projects/${projectId}/assistant-task-config`,
    LOGGER_TYPE.ANALYTICS,
    {
      task_name: taskName,
      question: question,
      prompt: prompt,
      categories: categories,
    },
    { prefix: 'nebula' },
  );
};

export const updateAssistantTask = (
  accountId: string,
  projectId: string,
  taskName: string,
  question: string,
  prompt: string,
  categories: CategoryRequest[],
  taskId: string,
) => {
  return doPut<AssistantTaskResponse>(
    `accounts/${accountId}/projects/${projectId}/assistant-task-config/${taskId}`,
    LOGGER_TYPE.ANALYTICS,
    {
      task_name: taskName,
      question: question,
      prompt: prompt,
      categories: categories,
    },
    { prefix: 'nebula' },
  );
};

export const deleteAssistantTask = (
  accountId: string,
  projectId: string,
  taskId: string,
) => {
  return doDelete<void>(
    `accounts/${accountId}/projects/${projectId}/assistant-task-config/${taskId}`,
    LOGGER_TYPE.ANALYTICS,
    {},
    { prefix: 'nebula' },
  );
};
